import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { SignInViaImpersonateUseCaseInterface } from 'domain/usecases';

export class RemoteSignInViaImpersonate
  implements SignInViaImpersonateUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<SignInViaImpersonateUseCaseInterface.Result>,
  ) {}

  async execute(
    params: SignInViaImpersonateUseCaseInterface.Params,
  ): Promise<SignInViaImpersonateUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'post',
      url: this.url,
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
